import Main from './Main.jsx';
import { useState, useEffect } from 'react';
import Header from './header.jsx';
import Navbar from './Navbar.jsx';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from "axios";
import WelcomeBox from './WelcomeBox.jsx';
import Footer from './Footer.jsx';

// Ordena por nome, tratando os números como números (ex: 2018-19 < 2019-20 < 2022-23)
const sortItems = (list) =>
    [...list].sort((a, b) =>
        a.name.localeCompare(b.name, 'pt', { numeric: true, sensitivity: 'base' })
    );

export default function FolderComponent(props) {
    const [items, setItems] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();

    // Compute path and path2 only when needed
    let path2 = '';
    let path = '';
    if (location.pathname.startsWith("/folder") || location.pathname === '/') {
        path2 = decodeURIComponent(location.pathname.replace(/^\/folder/, "").slice(1));
        path = "Repositório LMAC e MMAC" + (path2 ? "/" + path2 : "");
    }

    // Segmentos do caminho atual, ex: ["1º ano", "[Alge] Álgebra", "Apontamentos"]
    const pathSegments = path2 ? path2.split('/') : [];

    // Primeiro segmento (ano/curso) — usado para destacar o botão certo no Navbar
    const activeSection = pathSegments[0] || '';

    // Breadcrumb: todos os segmentos EXCETO o primeiro (esse já está representado
    // no Navbar), cada um com o caminho completo até esse nível para navegação
    const breadcrumbs = pathSegments.slice(1).map((segment, index) => ({
        name: segment,
        fullPath: pathSegments.slice(0, index + 2).join('/')
    }));

    const handleBreadcrumbClick = (fullPath) => {
        navigate(`/folder/${fullPath}`);
    };

    // Navbar click handler
    const handleClick = (name) => {
        navigate(`/folder/${name}`);
    };

    // Main folder click handler
    const handleClick2 = (name, pathInput) => {
        if (location.pathname.startsWith("/folder") || location.pathname === '/') {
            navigate(`/folder/${path2 ? path2 + "/" : ""}${name}`);
        } else if (location.pathname.startsWith("/search")) {
            navigate(`/folder/${pathInput}`);
        }
    };

    // Main file click handler
    // Abre o ficheiro diretamente numa nova aba (sem iframe), para o browser
    // usar o seu próprio visualizador nativo — corrige o problema no Safari/iOS
    // de só mostrar a primeira página quando embrulhado num iframe
    const handleClick3 = (name, pathInput) => {
        let url = "";
        const encodedName = encodeURIComponent(name);

        if (location.pathname.startsWith("/folder") || location.pathname === '/') {
            const filePath = path ? `${path}/${name}` : name;
            url = `https://backend-992345001586.europe-west1.run.app/download/${encodedName}?path=${encodeURIComponent(filePath)}`;
        } else if (location.pathname.startsWith("/search")) {
            const pathSearch = "Repositório LMAC e MMAC" + '/' + pathInput;
            url = `https://backend-992345001586.europe-west1.run.app/download/${encodedName}?path=${encodeURIComponent(pathSearch)}`;
        }

        window.open(url, "_blank");
    };

    // Title click handler
    const headerClickFunction = () => {
        navigate(`/`);
    };

    // Fetch items for folder or search
    useEffect(() => {
        if (location.pathname.startsWith("/folder") || location.pathname === '/') {
            if (path === "Repositório LMAC e MMAC") {
                setItems([]);
            } else {
                axios.get("https://backend-992345001586.europe-west1.run.app/list", { params: { path } })
                    .then(res => setItems(sortItems(res.data)))
                    .catch(() => setItems([]));
            }
        } else if (location.pathname.startsWith("/search")) {
            let value = decodeURIComponent(location.pathname.replace(/^\/search/, "").slice(1));
            if (value === '') return;
            axios.get("https://backend-992345001586.europe-west1.run.app/search", { params: { q: value } })
                .then(res => setItems(sortItems(res.data)))
                .catch(() => setItems([]));
        }
    }, [location.pathname, path]);

    // Search submit handler
    const submitFunction = (event) => {
        event.preventDefault();
        const formEl = event.currentTarget;
        const formData = new FormData(formEl);
        const searchQuery = formData.get("query");
        navigate(`/search/${searchQuery}`);
        event.target.reset();
    };

    // Render
    if (location.pathname === '/') {
        return (
            <>
                <Header clickFunction={headerClickFunction} actionFunction={submitFunction} />
                <Navbar clickFunction={handleClick} activeSection={activeSection} />
                <WelcomeBox name={props.name} userData={props.userData} />
                <Footer />
            </>
        );
    } else {
        return (
            <>
                <Header clickFunction={headerClickFunction} actionFunction={submitFunction} />
                <Navbar clickFunction={handleClick} activeSection={activeSection} />
                <div className="FolderBox">
                    <img className="solido-fundo solido-1" src="/solidos/tetraedro.png" alt="" aria-hidden="true" />
                    <img className="solido-fundo solido-2" src="/solidos/cubo.png" alt="" aria-hidden="true" />
                    <img className="solido-fundo solido-3" src="/solidos/dodecaedro.png" alt="" aria-hidden="true" />
                    <img className="solido-fundo solido-4" src="/solidos/icosaedro.png" alt="" aria-hidden="true" />

                    <div className="folder-content">
                        {location.pathname.startsWith("/folder") && breadcrumbs.length > 0 && (
                            <div className="breadcrumb">
                                {breadcrumbs.map((crumb, index) => (
                                    <span key={crumb.fullPath}>
                                        {index > 0 && <span className="breadcrumb-separator"> / </span>}
                                        {index === breadcrumbs.length - 1 ? (
                                            <span className="breadcrumb-item breadcrumb-current">
                                                {crumb.name}
                                            </span>
                                        ) : (
                                            <span
                                                className="breadcrumb-item"
                                                onClick={() => handleBreadcrumbClick(crumb.fullPath)}
                                            >
                                                {crumb.name}
                                            </span>
                                        )}
                                    </span>
                                ))}
                            </div>
                        )}
                        <Main filhos={items} clickFunction={handleClick2} clickFunction2={handleClick3} />
                    </div>
                </div>
                <Footer />
            </>
        );
    }
}
